module.exports = __webpack_public_path__ + "img/info_sp_17.df4051df.png";